import { useContext, useEffect, useState } from "react";
import { getBatch, getSortedCollection, matchQuery } from "sprint-common-web";

import { IntegratorContext } from "../context/IntegratorContext";
import { IntegratorItem } from "./IntegratorItem";
import { IntegratorListingFilters } from "./useIntegratorListingFilters";

export const useIntegratorListing = (filters: IntegratorListingFilters) => {
    const [items, setItems] = useState<IntegratorItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const { integratorItems, isLoading } = useContext(IntegratorContext);

    useEffect(() => {
        saveData();
    }, [filters, integratorItems.length]);

    const saveData = (): void => {
        const sortedAndFilteredItems = getSortedAndFilteredItems(integratorItems, filters);
        const itemsToDisplay = getBatch(sortedAndFilteredItems, filters.pageSize, filters.page);

        const modifiedItems = itemsToDisplay.filter((item) => item.isModified === true);

        setTotalItems(sortedAndFilteredItems.length);
        setItems(Array.from(new Set([...modifiedItems, ...itemsToDisplay])));
    };

    return {
        items,
        totalItems,
        isLoading,
        filters,
        saveData
    };
};

const getSortedAndFilteredItems = (items: IntegratorItem[], filters: IntegratorListingFilters) => {
    const sortedItems = getSortedCollection(items, filters.sortBy, filters.sortOrder);

    return filterItems(sortedItems, filters.name ?? "");
};

const filterItems = (items: IntegratorItem[], name: string) => items.filter((item) => matchQuery(item.name, name));
